
import React from "react";

export const TopicosHeader: React.FC = () => {
  return (
    <>
      <h1 className="text-2xl font-bold text-[#272f3c]">Tópicos</h1>
      <p className="text-[#67748a]">Gerenciamento de tópicos das aulas</p>
    </>
  );
};
